import { initFederation } from '@angular-architects/native-federation';

initFederation()
  .then(async federation => {
    const { bootstrap } = await import('./bootstrap');
    return bootstrap(federation);
  })
  .catch(error => console.error(error));
